import { render, staticRenderFns } from "./BillToManufacturers.vue?vue&type=template&id=5d1ce858"
import script from "./BillToManufacturers.vue?vue&type=script&lang=ts"
export * from "./BillToManufacturers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports